// extracted by mini-css-extract-plugin
module.exports = {"carouselItem":"Carousel_carouselItem__2KtoK","carouselWrapper":"Carousel_carouselWrapper__3YKYk"};